import TankSVG from './TankSVG'

/**
 * Moldura de "dispositivo" (tela do sistema) para o tanque no Hero.
 * Passa a sensação de produto real / dashboard ao vivo.
 */
const HeroDevice = () => {
  return (
    <div
      className="
        relative w-full max-w-[320px] mx-auto
        rounded-[1.75rem] sm:rounded-[2rem]
        bg-white dark:bg-gray-900
        border border-gray-200 dark:border-gray-700/80
        shadow-[0_20px_40px_-12px_rgba(0,0,0,0.12),0_0_0_1px_rgba(0,0,0,0.04)]
        dark:shadow-[0_25px_50px_-12px_rgba(0,0,0,0.5),0_0_0_1px_rgba(255,255,255,0.05)]
        overflow-hidden
        animate-float
      "
    >
      {/* Barra do app - estilo interface real */}
      <div
        className="
          flex items-center justify-between px-4 py-3
          bg-gray-50 dark:bg-gray-800/95
          border-b border-gray-200 dark:border-gray-700/60
        "
      >
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-accent animate-pulse" title="Ao vivo" />
          <span className="text-xs font-semibold text-gray-700 dark:text-gray-400 tracking-tight">
            Reservatório 01
          </span>
        </div>
        <span className="text-[10px] font-bold text-accent uppercase tracking-wider">
          Tempo real
        </span>
      </div>

      {/* Área da "tela" - conteúdo do tanque */}
      <div className="relative bg-gray-50/80 dark:bg-gray-900/50 p-2 sm:p-3">
        <div
          className="absolute top-0 left-0 right-0 h-20 pointer-events-none z-10 bg-gradient-to-b from-white/60 to-transparent dark:from-white/[0.03] dark:to-transparent"
        />
        <div className="relative">
          <TankSVG />
        </div>
      </div>
    </div>
  )
}

export default HeroDevice
